// extracted by mini-css-extract-plugin
export default {"option":"UserTypeOption_option__R9t2t","badge":"UserTypeOption_badge__ehSfV"};